import { useState, useEffect } from "react";

import { Box, Container, Grid, Typography } from "@mui/material";
import {
  findGetParameter,
  postData,
} from "../../components/utilities/UtilityFunctions";

import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { postNotification } from "../../components/utilities/Notifications";

export default function Unsubscribe(props) {
  const email = findGetParameter("email");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState();
  useEffect(() => {
    const go = async () => {
      setLoading(true);
      try {
        await postData(`/users/notifications/unsubscribe`, {
          body: {
            email: email,
          },
        });
        setMessage(`${email} has been unsubscribed from notifications`);
        postNotification(
          "info",
          "Your email has been unsubscribed from notifications"
        );
      } catch (err) {
        postNotification("error", err);
      }
      setLoading(false);
    };
    go();
  }, [email]);
  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container sx={{ gap: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
            }}
          >
            <Typography variant="h3" gutterBottom>
              Unsubscribe from Notifications
            </Typography>
            {message && (
              <Typography variant="body1" paragraph>
                {message}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Container>
      {loading && <ModalLoadingFull />}
    </Box>
  );
}
